<template>
  <div class="batch-list">
    <a-card :bordered="false">
      <a-form layout="inline" @submit.prevent>
        <a-form-item label="批次编号">
          <a-input v-model="searchForm.batchCode" placeholder="请输入批次编号" />
        </a-form-item>
        <a-form-item label="批次名称">
          <a-input v-model="searchForm.batchName" placeholder="请输入批次名称" />
        </a-form-item>
        <a-form-item label="状态">
          <a-select v-model="searchForm.status" placeholder="请选择" style="min-width: 100px">
            <a-select-option :value="0">关闭</a-select-option>
            <a-select-option :value="1">开启</a-select-option>
            <a-select-option :value="2">暂停</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="时间范围">
          <a-range-picker v-model="dateRange" @change="handleDateChange" />
        </a-form-item>
        <a-row justify="end" style="margin-top: 8px;">
          <a-col>
            <a-form-item>
              <a-button type="primary" icon="search" @click="fetchList" style="margin-right: 8px;">
                搜索
              </a-button>
              <a-button @click="resetSearch">重置</a-button>
            </a-form-item>
          </a-col>
        </a-row>

      </a-form>

      <div style="margin: 16px 0; text-align: left">
        <a-button type="primary" icon="plus" @click="goToCreate">
          新增批次
        </a-button>
      </div>
      <a-table
          rowKey="batchCode"
          :columns="columns"
          :dataSource="list"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
      >
        <template slot="action" slot-scope="text, record">
          <a-button type="link" @click="goToDetail(record.id)">详情</a-button>
        </template>
      </a-table>
    </a-card>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import request from '@/utils/request'

export default {
  name: 'BatchListPage',
  data() {
    return {
      searchForm: {
        batchCode: '',
        batchName: '',
        status: undefined,
        startDate: '',
        endDate: ''
      },
      dateRange: [],
      list: [],
      loading: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      columns: [
        { title: '批次编号', dataIndex: 'batchCode', key: 'batchCode' },
        { title: '批次名称', dataIndex: 'batchName', key: 'batchName' },
        { title: '总数量', dataIndex: 'codeCnt', key: 'codeCnt' },
        { title: '已使用', dataIndex: 'usedCount', key: 'usedCount' },
        { title: '未使用', dataIndex: 'unusedCount', key: 'unusedCount' },
        {
          title: '有效时间范围',
          key: 'validTimeRange',
          customRender: (text, record) => {
            const start = record.startTime || '';
            const end = record.endTime || '';
            return start && end ? `${start}～${end}` : '';
          }
        },
        { title: '创建时间', dataIndex: 'createTime', key: 'createTime' },
        { title: '状态', dataIndex: 'comboStatus', key: 'comboStatus',
          customRender: (text) => {
            const map = { 0: '关闭', 1: '开启', 2: '暂停' };
            return map[text] || '未知';
          }
        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  methods: {
    fetchList() {
      this.loading = true;
      const { batchCode, batchName, status, startDate, endDate } = this.searchForm;
      const params = {
        batchCode,
        batchName,
        status,
        pageNum: this.pagination.current,
        pageSize: this.pagination.pageSize
      };

      if (startDate) params.startDate = startDate;
      if (endDate) params.endDate = endDate;

      request.get('/video/convertcombo/getConvertComboPage', { params })
          .then(res => {
            const { records, total } = res.data || {};
            this.list = records || [];
            this.pagination.total = total || 0;
          }).finally(() => {
        this.loading = false;
      });
    },
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.searchForm.startDate = dayjs(dates[0]).format('YYYY-MM-DD');
        this.searchForm.endDate = dayjs(dates[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
    },
    resetSearch() {
      this.searchForm = {
        batchCode: '',
        batchName: '',
        status: undefined,
        startDate: '',
        endDate: ''
      };
      this.dateRange = [];
      this.pagination.current = 1;
      this.fetchList();
    },
    handleTableChange(pagination) {
      this.pagination.current = pagination.current;
      this.fetchList();
    },
    handleDateChange(dates) {
      if (dates && dates.length === 2) {
        this.searchForm.startDate = dayjs(dates[0]).format('YYYY-MM-DD');
        this.searchForm.endDate = dayjs(dates[1]).format('YYYY-MM-DD');
      } else {
        this.searchForm.startDate = '';
        this.searchForm.endDate = '';
      }
    },
    goToCreate() {
      this.$router.push('/redeem/combo/create');
    },
    goToDetail(rowId) {
      this.$router.push({ path: '/redeem/batch/detail', query: { id: rowId } })
    }
  },
  mounted() {
    this.fetchList();
  }
}
</script>

<style scoped>
.batch-list {
  padding: 24px;
}
</style>
